import { type Registry as Services, service } from '@ember/service';
import Component from '@glimmer/component';
import { PrismTable } from '@mylighthouse/prism-ember';
import HotelStrategyTablesCellsTdStrategyBaserate from 'lumen/components/hotel/strategy/tables/cells/td-strategy-baserate';
import HotelStrategyTablesCellsTdStrategyHotel from 'lumen/components/hotel/strategy/tables/cells/td-strategy-hotel';
import HotelStrategyTablesCellsThStrategyDetail from 'lumen/components/hotel/strategy/tables/cells/th-strategy-detail';
import { DAY_OF_WEEK_TRANSLATIONS } from 'lumen/utils/constants/general-constants';
import {
  COLUMN_CONFIG,
  COLUMN_PROPERTIES,
  COLUMN_WIDTH,
  SUBTYPE_DELIMITER,
} from 'lumen/utils/constants/rate-strategy-constants';

interface HotelStrategyTablesTableDetailDowSignature {
  Args: {
    initialSorts: unknown;
    onTableSort: unknown;
    sortFunction: unknown;
    subtypes: unknown;
  };
}

export default class HotelStrategyTablesTableDetailDow extends Component<HotelStrategyTablesTableDetailDowSignature> {
  @service declare intl: Services['intl'];

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get columns() {
    const valuePathHotel = COLUMN_PROPERTIES.HOTELINFO;
    const columns = [
      {
        ...COLUMN_CONFIG.HOTELINFO_HEADER,
        subcolumns: [
          {
            ...COLUMN_CONFIG.HOTELINFO,
            name: this.intl.t('general.hotels'),
            tdComponent: HotelStrategyTablesCellsTdStrategyHotel,
            valuePath: valuePathHotel,
          },
        ],
      },
    ];

    const dayColumn = {
      name: this.intl.t('revenue_insight.weekday'),
      thComponent: HotelStrategyTablesCellsThStrategyDetail,
      // @ts-expect-error: Incorrect type
      width: this.args.subtypes.length * COLUMN_WIDTH.DEFAULT,
      hasRightBorder: true,
      hasCompareButton: true,
      subcolumns: [],
    };

    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call
    this.args.subtypes.forEach((subtype, index) => {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      const valuePathRate = `${subtype.id}${SUBTYPE_DELIMITER}${COLUMN_PROPERTIES.RATE}`;
      // @ts-expect-error: Incorrect type
      dayColumn.subcolumns.push({
        // @ts-expect-error: Incorrect type
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-unsafe-member-access
        name: this.intl.t(DAY_OF_WEEK_TRANSLATIONS[subtype.label]),
        valuePath: valuePathRate,
        tdComponent: HotelStrategyTablesCellsTdStrategyBaserate,
        width: COLUMN_WIDTH.DEFAULT,
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
        columnKey: subtype.label,
        textAlign: 'center',
        // @ts-expect-error: Incorrect type
        hasRightBorder: index === this.args.subtypes.length - 1,
      });
    });

    // @ts-expect-error: Incorrect type
    columns.push(dayColumn);

    return columns;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get rows() {
    // @ts-expect-error: Incorrect type
    const rows = [];

    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
    const dowData = [...this.args.dowDataPerHotelInfo.values()];

    dowData.forEach((rowData) => {
      const row = {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
        [COLUMN_PROPERTIES.HOTELINFO]: rowData[COLUMN_PROPERTIES.HOTELINFO],
      };

      // @ts-expect-error: Incorrect type
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call
      this.args.subtypes.forEach((subtype) => {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
        row[`${subtype.id}${SUBTYPE_DELIMITER}${COLUMN_PROPERTIES.RATE}`] =
          // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
          rowData[subtype.id][COLUMN_PROPERTIES.RATE];
      });

      rows.push(row);
    });

    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return rows;
  }

  <template>
    <PrismTable
      {{! @glint-expect-error: Incorrect type }}
      @columns={{this.columns}}
      @enableAutoSortsUpdate={{true}}
      @fillMode="first-column"
      {{! @glint-expect-error: Incorrect type }}
      @initialSorts={{@initialSorts}}
      {{! @glint-expect-error: Incorrect type }}
      @onTableSort={{@onTableSort}}
      @removeTableBorder={{true}}
      @rows={{this.rows}}
      {{! @glint-expect-error: Incorrect type }}
      @sortFunction={{@sortFunction}}
      @widthConstraint="eq-container-slack"
    />
  </template>
}
